export const FIELD_IDS = {
    SIGNUP_PASSWORD_FIELD: 'signup_password',
    AUTH_PASSWORD_FIELD: 'auth_password',
    RECOVERY_PASSWORD_FIELD: 'recovery_password',
};

export const SECRET_FIELDS = [
    FIELD_IDS.AUTH_PASSWORD_FIELD,
    FIELD_IDS.RECOVERY_PASSWORD_FIELD,
    FIELD_IDS.SIGNUP_PASSWORD_FIELD,
];
